import { memo, useContext } from 'react';
import { TitleSourceSvg, VideoSourceSvg, JumpLinkOfQuestionSourceSvg } from '@/sub-luca-plugin/compatible-components/svg-icons';
import { navigateExample } from '@/sub-luca-plugin/utils/class-example';
import { IQuestionSource } from '..';
import { QaRecordsContext } from '../../helper';
import './index.scss';

const QuestionSource = ({
    sourceType,
    title,
    content,
    videoId,
    videoTime,
    questionId,
    permission,
    url,
}: Omit<IQuestionSource, 'recordId' | 'type' | 'role'>) => {
    const { toastInQa } = useContext(QaRecordsContext);

    const handleClickOrigin = () => {
        switch (sourceType) {
            case 'video':
                if (permission === 1) {
                    // 跳转
                    url
                        ? navigateExample.linkTo('webview', { url })
                        : navigateExample.linkTo('video', { title, videoId, initialTime: videoTime, isKeyframe: true });
                } else {
                    toastInQa?.('对不起，您未购买该课程，无法查看该视频。若要查看，请去购买哦。', 'warning');
                }
                break;
            case 'question':
                navigateExample.linkTo('problem_analysis', { questionId, color: '5262ff' });
                break;
            default:
                break;
        }
    };

    return (
        <div className="respondent-container">
            <div className="question-source">
                <div className="question-source__title">问题来源</div>
                <div className="question-source__info" onClick={handleClickOrigin}>
                    {sourceType === 'video' ? (
                        <VideoSourceSvg className="question-source__icon" />
                    ) : (
                        <TitleSourceSvg className="question-source__icon" />
                    )}
                    <div className="question-source__title">{content}</div>
                    {sourceType === 'question' && <JumpLinkOfQuestionSourceSvg className="question-source__link-icon" />}
                </div>
            </div>
        </div>
    );
};

export default memo(QuestionSource);
